import React, { useEffect, useState } from 'react'
import {
  Button,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Row,
  Table,
} from 'antd'
import ContentHeader from '../../components/shared/ContentHeader'
import { useRecoilState } from 'recoil'
import { userState } from '../../store/user'
import dayjs from 'dayjs'
import styles from '../../styles/product.module.scss'
import productApi from '../../api/product.api'
import BrandExcelUpload from '../../components/product/BrandExcelUpload'

const BrandListPage = () => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)

  const [mediaResult, setMediaResult] = useState(null)
  const [searchOptions, setSearchOptions] = useState({
    name: '',
    phone: '',
  })
  const [brandList, setBrandList] = useState([])
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [totalSize, setTotalSize] = useState(0)
  const [orderBy, setOrderBy] = useState('desc')
  const [orderType, setOrderType] = useState('id')

  const [brandModalShow, setBrandModalShow] = useState(false)
  const [sellerList, setSellerList] = useState([])

  const columns = [
    {
      title: '브랜드 아이디',
      // width: 110,
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      fixed: 'left',
      sorter: (a, b) => {},
    },
    {
      title: '브랜드명',
      // width: 120,
      dataIndex: 'brandName',
      key: 'brandName',
      fixed: 'left',
      ellipsis: true,
      sorter: (a, b) => {},
      render: (value) => {
        if (value === '') {
          return <span>-</span>
        } else {
          return value
        }
      },
    },
    {
      title: '판매자명',
      // width: 120,
      dataIndex: 'sellerName',
      key: 'sellerName',
      ellipsis: true,
      sorter: (a, b) => {},
      render: (value) => {
        if (value === '') {
          return <span>-</span>
        } else {
          return value
        }
      },
    },
    {
      title: '연락처',
      dataIndex: 'phone',
      key: 'phone',
      ellipsis: true,
    },
    {
      title: '사업자번호',
      // width: 120,
      dataIndex: 'businessNumber',
      key: 'businessNumber',
      ellipsis: true,
    },
    {
      title: '영업소재지',
      // width: 120,
      dataIndex: 'businessLocation',
      key: 'businessLocation',
      // ellipsis: true,
    },
    {
      title: '이메일',
      // width: 120,
      dataIndex: 'email',
      key: 'email',
      ellipsis: true,
      render: (value) => {
        if (value) {
          return value
        } else {
          return '-'
        }
      },
    },
    {
      title: '기본배송비',
      // width: 120,
      dataIndex: 'deliveryPrice',
      key: 'deliveryPrice',
      ellipsis: true,
      align: 'right',
      sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return value.toLocaleString() + '원'
        } else {
          return '-'
        }
      },
    },
    {
      title: '무료배송기준',
      // width: 120,
      dataIndex: 'deliveryPriceBaseline',
      key: 'deliveryPriceBaseline',
      ellipsis: true,
      align: 'right',
      sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return value.toLocaleString() + '원'
        } else {
          return '-'
        }
      },
    },
    {
      title: '등록일',
      // width: 160,
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
  ]

  const orderPair = {
    id: '브랜드아이디순',
    brandName: '브랜드순',
    sellerName: '판매자순',
    deliveryPrice: '배송비순',
    deliveryPriceBaseline: '무료배송기준순',
    createdAt: '등록일순',
  }

  /**
   * 모바일 처리 mobile -> true
   */
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const matchQueryList = window.matchMedia('all and (max-width: 768px)')
      setMediaResult(matchQueryList.matches)

      const media = function handleChange(e) {
        setMediaResult(e.matches)
      }

      matchQueryList.addEventListener('change', media)
    }
    readSellerList()
  }, [])

  useEffect(() => {
    readBrandList()
  }, [offset, pageSize, orderType, orderBy])

  /**
   * 판매자 전체 목록 조회
   * @returns {Promise<void>}
   */
  const readSellerList = async () => {
    setIsLoading(true)
    try {
      const res = await productApi.readSellerList(user.id)
      if (res.data.code === 200) {
        setSellerList(res.data.result)
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('readSellerList read error', error)
    }
  }

  /**
   * 브랜드 목록 검색
   * @param type
   * @returns {Promise<void>}
   */
  const readBrandList = async (type = '') => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          offset: 0,
          pageSize: 10,
          name: '',
          phone: '',
          orderType: 'id',
          orderBy: 'desc',
        }
      } else if (type === 'search') {
        param = {
          offset: 0,
          pageSize: 10,
          ...searchOptions,
          orderType: orderType,
          orderBy: orderBy,
        }
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          ...searchOptions,
          orderType: orderType,
          orderBy: orderBy,
        }
      }
      const res = await productApi.readBrandListForSearch(param, user.id)
      if (res.data.code === 200) {
        setBrandList(res.data.result.brandList)
        setTotalSize(res.data.result.totalCnt)
        setIsLoading(false)
      } else {
        setIsLoading(false)
        alert(
          '브랜드 목록을 조회하는데 오류가 발생했습니다.\n다시 시도하시거나 관리자에게 문의해주시길 바랍니다.',
        )
      }
    } catch (error) {
      setIsLoading(false)
      console.log('readBrandList read error', error)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    if (name === 'phone') {
      const reg = /^[0-9]*$/
      if (value === '' || reg.test(value)) {
        setSearchOptions({ ...searchOptions, [name]: value })
      }
    } else {
      setSearchOptions({ ...searchOptions, [name]: value })
    }
  }

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === 'descend') {
          setOrderBy('desc')
        } else if (sorter.order === 'ascend') {
          setOrderBy('asc')
        }
        setOrderType(sorter.field)
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType('id')
        setOrderBy('desc')
      }
    }
  }

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const offset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(offset)
  }

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
    setOffset(0)
    setCurrentPageNumber(1)
  }

  /**
   * 검색 버튼
   */
  const handleSearchBtnClick = async () => {
    if (searchOptions.category1 !== '' && searchOptions.category2 === '') {
      window.alert(
        '카테고리를 중분류까지 선택하거나 초기화한 뒤에 다시 검색해주시길 바랍니다.',
      )
    } else {
      setOffset(0)
      setCurrentPageNumber(1)
      readBrandList('search')
    }
  }

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      name: '',
      phone: '',
    })
    setOffset(0)
    setCurrentPageNumber(1)
    setOrderType('id')
    setOrderBy('desc')
    readBrandList('initial')
  }

  return (
    <>
      <ContentHeader title="브랜드 조회" />
      <div className={`${styles['product-register-wrap']}`}>
        {/*브랜드검색*/}
        <div className={`${styles['product-search-box-wrap']}`}>
          <Form.Item
            className={`${styles['center-label']}`}
            label="검색어"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle" gutter={[0, { xs: 8, md: 0 }]}>
              <label
                className={`${styles['product-search-box-input-label']}`}
                style={{ width: 110 }}
              >
                브랜드/판매자명
              </label>
              <Input
                className={`${styles['product-search-box-input-wrap']}`}
                name="name"
                value={searchOptions.name}
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
              <label
                className={`${styles['product-search-box-input-label']}`}
                style={{ width: mediaResult ? 110 : 70 }}
              >
                연락처
              </label>
              <Input
                className={`${styles['product-search-box-input-wrap']}`}
                name="phone"
                value={searchOptions.phone}
                placeholder="-를 제외하고 입력해주세요"
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Row
            className={`${styles['product-search-button-wrap']}`}
            justify="center"
          >
            <Button
              className={`${styles['product-search-button']} ${styles.search}`}
              onClick={handleSearchBtnClick}
            >
              검색
            </Button>
            <Button
              className={`${styles['product-search-button']} ${styles.initial}`}
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*상품목록*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          wrap={false}
          justify={'space-between'}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className={`${styles['product-register-box-title']}`}>
              브랜드목록 (총{' '}
              <span
                className={`${styles['product-register-box-subtitle']}`}
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className={`${styles['product-list-subtitle']}`}>
              {orderPair[orderType]}
            </span>
          </div>
          <Button
            style={{
              fontSize: '0.9em',
            }}
            onClick={() => setBrandModalShow(true)}
          >
            <img
              style={{ height: 14.2, width: 14.5, marginRight: 5 }}
              src={`${process.env.REACT_APP_HOST}/assets/icon/common/microsoftexcel.png`}
            />
            브랜드/판매자 추가
          </Button>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ padding: '20px 25px 40px', height: 'fit-content' }}
        >
          <Table
            columns={columns}
            dataSource={brandList}
            loading={isLoading}
            bordered
            size="middle"
            rowKey="id"
            rowClassName="coupon-table-row"
            // scroll={{ x: "calc(700px + 50%)" }}
            scroll={{ x: 'max-content' }}
            tableLayout={'auto'}
            onChange={tableOnChange}
            pagination={false}
          />

          <Pagination
            showSizeChanger
            onShowSizeChange={pageSizeChange}
            total={totalSize}
            current={currentPageNumber}
            onChange={handleChangePagination}
            align={'end'}
            style={{ marginTop: 20 }}
          />
        </div>
      </div>

      {brandModalShow && (
        <Modal
          className="excel-delivery-modal"
          title="브랜드/판매자 추가"
          open={brandModalShow}
          onCancel={() => setBrandModalShow(false)}
          footer={null}
          width={700}
          style={{ top: 50 }}
        >
          <BrandExcelUpload
            setBrandModalShow={setBrandModalShow}
            handleInitialBtnClick={handleInitialBtnClick}
            sellerList={sellerList}
          />
        </Modal>
      )}
    </>
  )
}

export default BrandListPage
